import {
  MailRequirement,
  PoliceRecordsInquiryMajorVendor,
  ReadDepartmentRecordsChannel,
} from '@/services/api/generated/policeDepartmentsService';

export interface RecordsChannelFormModalProps {
  departmentId: string;
  channel: ReadDepartmentRecordsChannel | null;
  onClose: () => void;
}

export interface ChannelFormData {
  handleType: string;
  instructions: string;
  handleValue: string;
  handleName: string;
  majorVendor: PoliceRecordsInquiryMajorVendor;

  // Mailing fields
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  payableTo: string;
  memoInstructions: string;
  waitDays: string;
  processingDays: string;
  specialRequirements: string;
  requiredItems: MailRequirement[];
  feeAmount: string;
}

export interface FormErrors {
  [key: string]: string;
}

export const HANDLE_TYPES = [
  {
    value: 'WEBSITE',
    label: 'Website / Portal',
    shortLabel: 'Website',
    description: 'Online portal for requesting records',
  },
  {
    value: 'MAILING_ADDRESS',
    label: 'Mail Request',
    shortLabel: 'Mail',
    description: 'Physical mail with check payment',
  },
  {
    value: 'PHONE',
    label: 'Phone',
    shortLabel: 'Phone',
    description: 'Phone number for records inquiries',
  },
  {
    value: 'EMAIL',
    label: 'Email',
    shortLabel: 'Email',
    description: 'Email contact',
  },
  {
    value: 'FAX',
    label: 'Fax',
    shortLabel: 'Fax',
    description: 'Fax number',
  },
] as const;

export const MAJOR_VENDORS = [
  { value: 'not_a_portal', label: 'Not a Portal' },
  { value: 'carfax_crashdocs', label: 'CrashDocs (Carfax)' },
  { value: 'lexis_nexis_buycrash', label: 'BuyCrash (LexisNexis)' },
  { value: 'independent_portal', label: 'Independent Portal' },
  { value: 'txdot_cris', label: 'TxDOT CRIS' },
] as const;

export const MAIL_REQUIREMENTS = [
  { value: 'CLIENT_PHOTO_ID_COPY', label: 'Client Photo ID Copy' },
  { value: 'FIRM_LETTERHEAD', label: 'Firm Letterhead' },
  { value: 'PROOF_OF_REPRESENTATION', label: 'Proof of Representation' },
  { value: 'COMPLETED_REQUEST_FORM', label: 'Completed Request Form' },
  { value: 'NOTARIZED_REQUEST_FORM', label: 'Notarized Request Form' },
] as const;
